import React from "react";
import styled from "styled-components";
import { useParams, useLocation } from "react-router-dom";
import SearchContainer from "../containers/SearchContainer";
import FilterContainer from "../containers/FilterContainer";
import JobContainer from "../containers/JobContainer";
import MapContainer from "../containers/MapContainer";
import qs from "qs";

const LeftView = styled.div`
  position: absolute;
  width: 340px;
  left: 1.429em;
  top: 6em;
  z-index: 50;
`;

const SearchView = styled.div`
  position: absolute;
  width: 340px;
  left: 1.429em;
  top: 2.143em;
  z-index: 50;
`;

const App = () => {
  const { id: jobId } = useParams();
  const location = useLocation();
  const endpoint =
    qs.parse(location.search, { ignoreQueryPrefix: true }).endpoint ||
    "https://routing-engine.afi.io";

  return (
    <div>
      <LeftView>
        <JobContainer jobId={jobId} endpoint={endpoint} />
        <FilterContainer />
      </LeftView>
      <SearchView>
        <SearchContainer />
      </SearchView>
      <MapContainer />
    </div>
  );
};

export default App;
